/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import './dep-eba62589.mjs';
import { _ as _baseGetTag } from './dep-7d9e11c8.mjs';
import { i as isArray_1 } from './dep-b9567f6a.mjs';
import './dep-654b4b01.mjs';
import { i as isObjectLike_1 } from './dep-a6022780.mjs';

var baseGetTag = _baseGetTag,
  isArray = isArray_1,
  isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
var isString_1 = isString;

export { isString_1 as i };
//# sourceMappingURL=dep-7f2f03b4.mjs.map
